var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStarRecipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23236 2.53374C8.47394 1.82209 9.52581 1.82209 9.7674 2.53374L10.6306 5.07646C10.7386 5.39472 11.0485 5.6102 11.3981 5.6102H14.1913C14.9731 5.6102 15.2981 6.56773 14.6657 7.00755L12.4059 8.57904C12.123 8.77573 12.0047 9.12439 12.1127 9.44265L12.9759 11.9854C13.2175 12.697 12.3665 13.2888 11.734 12.849L9.47423 11.2775C9.19138 11.0808 8.80837 11.0808 8.52553 11.2775L6.26574 12.849C5.63328 13.2888 4.78229 12.697 5.02388 11.9854L5.88703 9.44265C5.99507 9.12439 5.87672 8.77573 5.59387 8.57904L3.33409 7.00755C2.70162 6.56773 3.02667 5.6102 3.80844 5.6102H6.60168C6.9513 5.6102 7.26116 5.39472 7.3692 5.07646L8.23236 2.53374Z",
    fill: "url(#paint0_linear_242_5147)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_5147",
    x1: 8.99988,
    y1: 2,
    x2: 8.99988,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD09A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarRecipe);
export default __webpack_public_path__ + "static/media/RatingStarRecipe.bb9e65c6a499710b4c272548b5af912e.svg";
export { ForwardRef as ReactComponent };